var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyPersonaSize40(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "#F6E7F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 13.1566C15.4467 13.9842 15.1238 14.9784 15.1238 16.0467C15.1238 18.9212 17.4622 21.26 20.3371 21.26C23.2116 21.26 25.5504 18.9216 25.5504 16.0467C25.5504 13.1718 23.212 10.8334 20.3371 10.8334C20.329 10.8334 20.3209 10.8334 20.3128 10.8334C20.3048 10.8334 20.2968 10.8334 20.2888 10.8334C18.4963 10.8334 16.9158 11.7586 16 13.1566ZM16.9852 16.0467C16.9852 14.1988 18.489 12.695 20.3369 12.695C22.1844 12.695 23.6882 14.1988 23.6882 16.0467C23.6882 17.8942 22.1844 19.398 20.3369 19.398C18.4889 19.398 16.9852 17.8942 16.9852 16.0467ZM18.7205 21.5128C17.0564 21.5128 15.5096 22.2709 14.478 23.5905C13.7296 24.5479 13.3334 25.693 13.3334 26.8999V29.1667H15.416V26.8999C15.416 25.0784 16.8983 23.5961 18.7202 23.5961H21.955C23.7766 23.5961 25.2592 25.0784 25.2592 26.8999V29.1667H27.3425V26.8999C27.3425 25.0813 26.4291 23.3967 24.9006 22.3944C24.0214 21.8178 23.0028 21.5128 21.9554 21.5128H18.7205Z",
    fill: "#A614B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyPersonaSize40);
export default __webpack_public_path__ + "static/media/my-persona-size40.a2b1e40360bb8a6b2cfd7903382db0a0.svg";
export { ForwardRef as ReactComponent };